import React, { useState } from 'react';
import cs from 'classnames';
import styles from './index.module.less';
import V2FilterFooter from './V2FilterFooter';
import V2FormRangePicker from '../../..//Form/V2FormRangePicker/V2FormRangePicker';
import dayjs from 'dayjs';
import { useMethods } from '@lhb/hook';
import { isEqual, isNotEmpty, isNotEmptyAny } from '@lhb/func';
const V2FilterRangePicker: React.FC<any> = ({
  name,
  headFilter,
  setHeadFilter,
  cacheHeadFilter,
  close,
  comType,
  extra,
}) => {
  const [targetValue, setTargetValue] = useState<any>(headFilter[name]);
  const methods = useMethods({
    confirm(newValue, force = false) {
      close();
      if (force) {
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      } else if (!isEqual(headFilter[name], newValue)) {
        if (!isNotEmpty(newValue) && !isNotEmpty(headFilter[name])) {
          return;
        }
        setHeadFilter({
          ...headFilter,
          [name]: newValue
        });
      }
    },
    handleSearch() {
      methods.confirm(targetValue);
    },
    clearFiltersAndClose() {
      const noValue = {
        comType,
        value: [],
        extra
      };
      if (isNotEmptyAny(targetValue?.value)) {
        methods.confirm(noValue, true);
      } else {
        methods.confirm(noValue);
      }
      setTargetValue(noValue);
    }
  });
  return (
    <div className={cs([styles.V2TableFilterCommon, styles.V2FilterRangePicker])}>
      <div>
        <V2FormRangePicker
          noStyle
          config={{
            defaultValue: targetValue?.value?.map(item => dayjs(item, 'YYYY-MM-DD')),
            onChange(value) {
              let newValue: any;
              if (Array.isArray(value) && value.filter(item => isNotEmpty(item)).length) {
                newValue = [dayjs(value[0] as any).format('YYYY-MM-DD'), dayjs(value[1] as any).format('YYYY-MM-DD')];
              }
              const res = {
                comType,
                value: newValue,
                extra
              };
              setTargetValue(res);
              cacheHeadFilter.current = {
                ...cacheHeadFilter.current,
                [name]: res
              };
            }
          }}
        />
      </div>
      <V2FilterFooter
        handleSearch={methods.handleSearch}
        clearFiltersAndClose={methods.clearFiltersAndClose}
      />
    </div>
  );
};

export default V2FilterRangePicker;
